import { masmovilAlertOverride, llamayaAlertOverride } from './alert'
import { masmovilAppBarOverride, llamayaAppBarOverride } from './appBar'
import breakpoints from './breakpoints'
import { masmovilButtonOverride, llamayaButtonOverride } from './button'
import cardOverride from './card'
import {
  masmovilCircularProgressOverride,
  llamayaCircularProgressOverride,
} from './circularProgress'
import { masmovilPalette, llamayaPalette } from './colors'
import { masmovilDatePickerOverride, llamayaDatePickerOverride } from './datePicker'
import dividerOverride from './divider'
import { fonts, robotoBold, robotoRegular } from './fonts'
import helperTextOverride from './helperText'
import { masmovilIconButtonOverride, llamayaIconButtonOverride } from './iconButton'
import { masmovilLinearProgressOverride, llamayaLinearProgressOverride } from './linearProgress'
import { masmovilLinkOverride, llamayaLinkOverride } from './link'
import paperOverride from './paper'
import { masmovilRadioOverride, llamayaRadioOverride } from './radio'
import { masmovilSwitchOverride, llamayaSwitchOverride } from './switch'
import { masmovilTabOverride, llamayaTabOverride } from './tab'
import textFieldOverride from './textField'
import typography, { masmovilTypographyOverride, llamayaTypographyOverride } from './typography'
import { CustomTheme, CustomThemeOptions, createMyTheme } from './utils'

const masmovilThemeOptions: CustomThemeOptions = {
  overrides: {
    ...masmovilButtonOverride,
    ...masmovilLinkOverride,
    ...cardOverride,
    ...paperOverride,
    ...dividerOverride,
    ...helperTextOverride,
    ...textFieldOverride,
    ...masmovilTypographyOverride,
    ...masmovilAppBarOverride,
    ...masmovilAlertOverride,
    ...masmovilIconButtonOverride,
    ...masmovilRadioOverride,
    ...masmovilSwitchOverride,
    ...masmovilDatePickerOverride,
    ...masmovilTabOverride,
    ...masmovilLinearProgressOverride,
    ...masmovilCircularProgressOverride,
    MuiCssBaseline: {
      '@global': {
        '@font-face': [robotoRegular, robotoBold],
      },
    },
  },
  spacing: 4,
  typography: {
    fontSize: 16,
    fontFamily: fonts.primary,
    ...typography,
  },
  palette: { type: 'light', ...masmovilPalette },
  breakpoints,
}

export const masmovilTheme: CustomTheme = createMyTheme(masmovilThemeOptions, 'masmovil')

const llamayaThemeOptions: CustomThemeOptions = {
  overrides: {
    ...llamayaButtonOverride,
    ...llamayaLinkOverride,
    ...cardOverride,
    ...paperOverride,
    ...dividerOverride,
    ...helperTextOverride,
    ...textFieldOverride,
    ...llamayaTypographyOverride,
    ...llamayaAppBarOverride,
    ...llamayaAlertOverride,
    ...llamayaIconButtonOverride,
    ...llamayaRadioOverride,
    ...llamayaSwitchOverride,
    ...llamayaDatePickerOverride,
    ...llamayaTabOverride,
    ...llamayaLinearProgressOverride,
    ...llamayaCircularProgressOverride,
    MuiCssBaseline: {
      '@global': {
        '@font-face': [robotoRegular, robotoBold],
      },
    },
  },
  spacing: 4,
  typography: {
    fontSize: 16,
    fontFamily: fonts.primary,
    ...typography,
  },
  palette: { type: 'light', ...llamayaPalette },
  breakpoints,
}

export const llamayaTheme: CustomTheme = createMyTheme(llamayaThemeOptions, 'llamaya')
